// src/pages/ExamSessions/ExamSessionNew.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useExamSessions } from '../../hooks/useExamSessions';
import ExamSessionForm from '../../components/forms/ExamSessionForm';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const ExamSessionNew = () => {
  const navigate = useNavigate();
  const { addExamSession } = useExamSessions();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const result = await addExamSession(formData);
      if (result.success) {
        alert('Exam session created successfully!');
        navigate('/exam-sessions');
      } else {
        alert(result.error || 'Failed to create exam session');
      }
    } catch (e) {
      console.error('Error creating exam session:', e);
      alert('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/exam-sessions');
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <Button
          variant="outline"
          onClick={handleCancel}
          className="flex items-center"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-1" />
          Back
        </Button>
        <h1 className="text-xl font-bold text-gray-900">Add New Exam Session</h1>
      </div>

      <Card>
        <ExamSessionForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          loading={loading}
        />
      </Card>
    </div>
  );
};

export default ExamSessionNew;
